import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-alerta-de-feedback',
  templateUrl: './alerta-de-feedback.component.html',
  styleUrls: ['./alerta-de-feedback.component.scss']
})
export class AlertaDeFeedbackComponent {
  @Input() mensagem = "";
  @Input() titulo = "";
}
